import { useTranslation } from 'next-i18next';
import { cn } from '@/utils';
import { type CategoryNode } from '@/views/build/features/category-tree';
import { ColumnUI } from './ColumnUI';

/**
 * 단순 버튼 리스트 선택 컴포넌트
 *
 * 사용처: 학교급, 학년, 학기
 *
 * @example
 * <PlainSelection
 *   value={gradeId}
 *   label="학년"
 *   options={gradeOptions}
 *   onChange={setGradeId}
 * />
 */
export const PlainSelection = (props: PlainSelectionProps) => {
  const {
    label,
    error,
    isActive
  } = props;
  return <div className={cn('flex min-h-0 h-full flex-1 flex-col gap-4xs', !isActive && 'opacity-[0.32]')} data-sentry-component="PlainSelection" data-sentry-source-file="PlainSelection.tsx">
      <ColumnUI.Header label={label} required error={error} data-sentry-element="unknown" data-sentry-source-file="PlainSelection.tsx" />
      <div className="-m-3xs min-h-0 flex-1 overflow-auto p-3xs">
        <Options {...props} data-sentry-element="Options" data-sentry-source-file="PlainSelection.tsx" />
      </div>
    </div>;
};
const Options = (props: PlainSelectionProps) => {
  const {
    t
  } = useTranslation(['build']);
  if (!props.isActive) return null;
  if (props.isEmpty) return <ColumnUI.SelectButton isSelected={false} onClick={() => {}} disabled>
        {t('build.category.noApplicable')}
      </ColumnUI.SelectButton>;
  return props.options.map((option, index) => {
    return <ColumnUI.SelectButton key={option.nodeId} className={cn(!!props.error && index === 0 && 'focus-ring')} isSelected={props.value?.nodeId === option.nodeId} onClick={() => props.onChange(option)} onMouseEnter={() => props.onHover?.(option)} onMouseLeave={() => props.onHoverLeave?.()}>
        {option.label}
      </ColumnUI.SelectButton>;
  });
};
export interface PlainSelectionProps {
  value?: CategoryNode;
  label: string;
  options: CategoryNode[];
  error?: string;
  isActive?: boolean;
  isEmpty?: boolean;
  onChange: (node: CategoryNode) => void;
  onHover?: (node: CategoryNode) => void;
  onHoverLeave?: () => void;
}